/**
 * Land Details Form Section
 * Collects land ownership status with situation-specific sub-forms.
 */

import * as React from "react";
import { EditRoadIcon } from "@porchpass/ui";
import { FormTable, FormTableBody } from "@porchpass/ui";
import { LandFields, type LandData as UiLandData } from "@porchpass/ui";
import { useApplicationFormStore } from "../hooks/useApplicationFormStore";
import type { LandData } from "../types/applicationTypes";

export const LandDetailsForm: React.FC = () => {
  const store = useApplicationFormStore();
  const land = store.data.land;

  const landErrors = React.useMemo(() => {
    const result: Partial<Record<keyof LandData, string>> = {};
    for (const [k, v] of Object.entries(store.fieldErrors)) {
      if (k.startsWith("land.") && !k.startsWith("land.propertyAddress.")) {
        result[k.slice("land.".length) as keyof LandData] = v;
      }
    }
    return result;
  }, [store.fieldErrors]);

  const handleChange = (updates: Partial<UiLandData>) => {
    for (const key of Object.keys(updates)) {
      const errorKey = `land.${key}`;
      if (store.fieldErrors[errorKey]) {
        store.clearFieldError(errorKey);
      }
    }
    if (store.fieldErrors["land.landSituation"]) {
      store.clearFieldError("land.landSituation");
    }
    store.updateLand(updates as Partial<LandData>);
  };

  return (
    <div className="space-y-6">
      <FormTable
        title="Land Details"
        subtitle="Who owns the land where the home will be placed"
        headerIcon={
          <EditRoadIcon
            variant="bulk-rounded"
            size={16}
            className="text-[#6F41E6]"
          />
        }
      >
        <FormTableBody>
          <LandFields
            value={land}
            onChange={handleChange}
            errors={landErrors}
          />
        </FormTableBody>
      </FormTable>
    </div>
  );
};

export default LandDetailsForm;
